import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-details-propagate-default-dialog',
    template: require('./details-propagate-default.dialog.html')
})

export class DetailsPropagateDefaultDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<DetailsPropagateDefaultDialog>) public dialogRef: MatDialogRef<DetailsPropagateDefaultDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
